<div class="ajax-select-tool">
  {{> elements/_page_builder_label label=config.label description=config.description}}
  {{sp_select_tag "" class="tool-field" searchable=true required=config.required includeBlank=false}}
  <div class="customized shared-component-options">
    <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
  </div>
  {{> elements/_hint hint=config.hint}}
</div>
